module.exports = __webpack_public_path__ + "img/photo-30.05b5ca33.jpg";